import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import resources from './translations/translations';

i18next
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        debug: import.meta.env.MODE === 'development',
        ns: ['global'],
        fallbackLng: 'cs',
        load: 'languageOnly',
        interpolation: {
            escapeValue: false,
        },
        react: {
            useSuspense: false,
        },
        defaultNS: 'global',
        resources,
        detection: {
            order: [
                'path',
                'cookie',
                'localStorage',
                'sessionStorage',
                'navigator',
            ],
        },
    });

export default i18next;

const formatCZK = new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: 'CZK',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
});

/*
const formatEUR = new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
});
*/

export const formatPrice = (price: number) => {
    switch (i18next.resolvedLanguage) {
        default:
            return formatCZK.format(price);
        /*default:
            return formatEUR.format(price);*/
    }
};
